import React, { useEffect, useState, useRef } from "react";
import Contact from "./../../assets/contactpage.webp";

const ContactHero = () => {
  const text = "Get in Touch With Us";
  const words = text.split(" "); // Split text into words for animation
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    // Define keyframes dynamically
    const fadeInKeyframes = `
      @keyframes fadeInWord {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    // Inject keyframes into the document head
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = fadeInKeyframes;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    // IntersectionObserver to detect when 30% of hero section is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (heroRef.current) observer.observe(heroRef.current);

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
    };
  }, []);

  // 🎯 Ultra-Smooth Scrolling with requestAnimationFrame
const smoothScrollTo = (targetPosition, duration = 800) => {
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  let startTime = null;

  function animationStep(timestamp) {
    if (!startTime) startTime = timestamp;
    const timeElapsed = timestamp - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // Ensure it doesn't exceed 1

    // Ease-in-out quadratic function for smooth scrolling
    const easeInOutQuad =
      progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

    window.scrollTo(0, startPosition + distance * easeInOutQuad);

    if (timeElapsed < duration) {
      requestAnimationFrame(animationStep);
    }
  }

  requestAnimationFrame(animationStep);
};

// 📌 Function to scroll to the "Contact Form" section
const scrollToContactForm = (e) => {
  e.preventDefault(); // Prevents default anchor behavior

  const contactSection = document.getElementById("contact-form");
  if (contactSection) {
    const yOffset = contactSection.getBoundingClientRect().top + window.scrollY - 50; // Adjust for navbar
    smoothScrollTo(yOffset, 1000); // 🔥 Ultra-smooth scroll with 1s duration
  } else {
    console.error("❌ #contact-form section not found!");
  }
};

// 📍 Apply this function to the "Contact Us" button
<a href="#contact-form" onClick={scrollToContactForm} style={styles.button}>
  Contact Us
</a>;


  return (
    <section ref={heroRef} style={styles.heroContainer}>
      <div style={styles.overlay}>
        <h1 style={styles.heading}>
          {words.map((word, index) => (
            <span
              key={index}
              style={{
                opacity: isVisible ? 1 : 0,
                display: "inline-block",
                animation: isVisible ? `fadeInWord 0.6s forwards` : "none",
                animationDelay: isVisible ? `${index * 0.3}s` : "0s",
                marginRight: "10px",
              }}
            >
              {word}
            </span>
          ))}
        </h1>
        <p style={styles.subText}>We’d love to hear from you! Reach out today.</p>

        {/* 🔥 Button with smooth scroll function */}
        <button onClick={scrollToContactForm} style={styles.button}>
          Contact Us
        </button>
      </div>
    </section>
  );
};

// Inline styles
const styles = {
  heroContainer: {
    width: "100vw",
    height: "100vh",
    backgroundImage: `url(${Contact})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    padding: "40px",
    borderRadius: "10px",
    maxWidth: "90%",
  },
  heading: {
    fontSize: "clamp(2.5rem, 6vw, 5rem)",
    fontWeight: "bold",
    marginBottom: "10px",
    wordWrap: "break-word",
  },
  subText: {
    fontSize: "1.5rem",
    marginBottom: "20px",
  },
  button: {
    padding: "12px 30px",
    fontSize: "1.2rem",
    color: "#fff",
    backgroundColor: "#d72638",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background 0.3s ease",
  },
};

export default ContactHero;
